import React, { useEffect, useRef, useState } from 'react'
import { get } from '~/utils/api'

const DownloadButton = ({ url }) => (
  <a href={url} target="_blank" className="button is-small">
    <span className="fa fa-download"></span>
  </a>
)

const downloadRecordingUrl = async (id, setRecordingUrls) => {
  const result = await get(`calls/${id}/recording/url`)

  setRecordingUrls(result)
}

let PlayerInit = ({ item, setRecordingUrls }) => {
  return (
    <div className="call-list-player">
      <div className="call-list-player-buttons">
        <a
          href="#"
          className="button is-small"
          onClick={e => {
            e.preventDefault()
            downloadRecordingUrl(item.id, setRecordingUrls)
          }}
        >
          <span className="fa fa-play"></span>
        </a>
      </div>
    </div>
  )
}

const PlayerReal = ({ item, recordingUrls }) => {
  const [active, setActive] = useState<any>(false)
  const ref: any = useRef()
  const setActiveRef: any = useRef()

  setActiveRef.current = setActive

  const toggle = key => {
    const audioEls = [...ref.current.querySelectorAll('audio')]

    if (active === key) {
      audioEls[key].pause()
      setActive(false)
    } else {
      if (active !== false) {
        audioEls[active].pause()
      }

      audioEls[key].play()
      setActive(key)
    }
  }

  useEffect(() => {
    toggle(0)
    ;[...ref.current.querySelectorAll('audio')].map(audio =>
      audio.addEventListener('ended', e => {
        audio.currentTime = 0

        setActiveRef.current(false)
      })
    )
  }, [])

  return (
    <div ref={ref}>
      {recordingUrls.map((url, key) => (
        <div className="call-list-player" key={key}>
          <div className="call-list-player-buttons">
            <button
              className="button btn-default  is-small"
              onClick={e => toggle(key)}
            >
              {active === key ? (
                <span className="fa fa-pause"></span>
              ) : (
                <span className="fa fa-play"></span>
              )}
            </button>

            <DownloadButton url={url} />
          </div>

          <audio>
            <source src={url} type="audio/ogg" />
          </audio>
        </div>
      ))}
    </div>
  )
}

let Player = ({ item }) => {
  const [recordingUrls, setRecordingUrls] = useState([])

  return !recordingUrls.length ? (
    <PlayerInit item={item} setRecordingUrls={setRecordingUrls} />
  ) : (
    <PlayerReal item={item} recordingUrls={recordingUrls} />
  )
}

export default Player
